
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class TradeMacroDialog extends SiteEntityDialog<TradeMacroRow, any> {
        protected getFormKey() { return TradeMacroForm.formKey; }
        protected getIdProperty() { return TradeMacroRow.idProperty; }
        protected getLocalTextPrefix() { return TradeMacroRow.localTextPrefix; }
        protected getNameProperty() { return TradeMacroRow.nameProperty; }
        protected getService() { return TradeMacroService.baseUrl; }

        protected form = new TradeMacroForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Steps.macroCode = this.entityId;
            this.updateInterface();
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.Steps.set_readOnly(this.form.Steps.get_readOnly() || this.isNew());
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 280;
            this.form.Steps.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }
    }
}